import { render } from "./RestaurantDetails.vue?vue&type=template&id=6973bf27&scoped=true"
import script from "./RestaurantDetails.vue?vue&type=script&lang=js"
export * from "./RestaurantDetails.vue?vue&type=script&lang=js"

import "./RestaurantDetails.vue?vue&type=style&index=0&id=6973bf27&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mkapp\\OneDrive\\Desktop\\Stage_Project\\Application_Front-end\\Moroccan-fork-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6973bf27"]])

export default __exports__